import React from 'react';

class ImagesPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imagesList: Array.from(props.images).map((file) => {
        return {
          key: file.name,
          url: null,
        };
      }),
    };
    this.showThumbnails();
  }

  showThumbnails(nextProps) {
    const { images } = nextProps || this.props;
    const { imagesList } = this.state;
    let _imagesList = imagesList.slice();
    for (let i = 0; i < images.length; i++) {
      let reader = new FileReader();
      reader.readAsDataURL(images[i]);
      reader.onload = (e) => {
        _imagesList[i].url = e.target.result;
        this.setState({imagesList: _imagesList});
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const nextImages = nextProps.images;
    if (!this.compareFileList(nextImages, this.props.images)) {
      this.setState({
        imagesList: Array.from(nextImages).map((file) => {
          return {
            key: file.name,
            url: null,
          };
        }),
      });
      this.showThumbnails(nextProps);
    }
  }

  // True: equals, False: different
  compareFileList(fileListA, fileListB) {
    if (fileListA.length !== fileListB.length)
      return false;
    for (let i = 0; i < fileListA.length; i++) {
      if (fileListA[i].name !== fileListB[i].name) {
        return false;
      }
    }
    return true;
  }

  render() {
    const { images, image_flags, removeImage } = this.props;
    const { imagesList } = this.state;

    return (
      <div className="hu-images-preview">
        { imagesList.map((file, index) => {
            if (image_flags[index]) {
              return (
                <div 
                  className="thumbnail" 
                  key={file.key}
                  style={file.url && `background-image: url(${file.url});`}
                >
                  <div className="thumbnail-button">
                    <svg className="hu-fill_accent"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      x="3650"
                      y="3688"
                      viewBox="0 0 610 610"
                      onclick={() => {removeImage(file.key);}}
                    >
                      <path fill d="M387.128,170.748L306,251.915l-81.128-81.167l-54.124,54.124L251.915,306l-81.128,81.128l54.085,54.086L306,360.086 l81.128,81.128l54.086-54.086L360.086,306l81.128-81.128L387.128,170.748z M522.38,89.62 c-119.493-119.493-313.267-119.493-432.76,0c-119.493,119.493-119.493,313.267,0,432.76 c119.493,119.493,313.267,119.493,432.76,0C641.873,402.888,641.873,209.113,522.38,89.62z M468.295,468.295 c-89.62,89.619-234.932,89.619-324.551,0c-89.62-89.62-89.62-234.932,0-324.551c89.62-89.62,234.931-89.62,324.551,0 C557.914,233.363,557.914,378.637,468.295,468.295z"></path>
                    </svg>
                  </div>
                </div>
              )
            } else {
              return null;
            }
          }
        )}
      </div>
    );
  }
}

export default ImagesPreview;


// WEBPACK FOOTER //
// ./app/js/components/messenger/input/ImagesPreview.js